import { useGetCapabilitiesQuery } from '@/modules/services';
import ElaPermissions from './permissions/permission.type';
import { hasRole } from './useUserHasRoles';
import { Roles } from './roles/roles.type';
import { useEffect, useState } from 'react';

interface UseUserHasCapabilitiesOptions {
  skip?: boolean;
}

export function useUserHasCapabilities(
  allowedCapabilities: ElaPermissions[],
  options: UseUserHasCapabilitiesOptions = {},
) {
  const { skip = false } = options;
  const userCapabilities = useGetCapabilitiesQuery('', { skip });
  const [hasCapabilities, setHasCapabilities] = useState<boolean | undefined>();

  useEffect(() => {
    if (skip) {
      setHasCapabilities(false);
      return;
    }

    if (userCapabilities.isLoading || !userCapabilities.data) return;

    const isElmoAdmin = hasRole(
      [Roles.Super, Roles.Admin, Roles.Migration],
      userCapabilities.data.roles,
    );
    const isCapable = userCapabilities.data.elaCapabilities.some((item) =>
      allowedCapabilities.includes(item),
    );

    // update return value
    if (isElmoAdmin) {
      setHasCapabilities(true);
    } else {
      setHasCapabilities(isCapable);
    }
  }, [
    userCapabilities.data,
    userCapabilities.isLoading,
    skip,
    allowedCapabilities,
  ]);

  return hasCapabilities;
}
